import { render, staticRenderFns } from "./RoleDashboardPage.vue?vue&type=template&id=37f454f6&scoped=true&"
import script from "./RoleDashboardPage.vue?vue&type=script&lang=js&"
export * from "./RoleDashboardPage.vue?vue&type=script&lang=js&"
import style0 from "./RoleDashboardPage.vue?vue&type=style&index=0&id=37f454f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f454f6",
  null
  
)

export default component.exports